module.exports = __webpack_public_path__ + "img/appService.48bd14d2.jpeg";